import { render, staticRenderFns } from "./ParametroCredorBancario.vue?vue&type=template&id=3f4c84a2&"
import script from "./ParametroCredorBancario.vue?vue&type=script&lang=js&"
export * from "./ParametroCredorBancario.vue?vue&type=script&lang=js&"
import style0 from "./ParametroCredorBancario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports